import { createSlice } from '@reduxjs/toolkit';
import {
  TAB_FABRICATION,
  TAB_STENCILS,
  TAB_PCB_PARTS,
  TAB_ACCESSORIES,
  TAB_ASSEMBLY,
} from 'shared/product_tabs/tabs/tabType';

const isValidTab = (tab) => [
  TAB_FABRICATION,
  TAB_STENCILS,
  TAB_PCB_PARTS,
  TAB_ACCESSORIES,
  TAB_ASSEMBLY,
].includes(tab);

let initialTab;

if (isValidTab(Spree.active_tab)) {
  initialTab = Spree.active_tab;
} else if (Spree.fabrication) {
  initialTab = TAB_FABRICATION;
} else if (Spree.stencils) {
  initialTab = TAB_STENCILS;
} else if (Spree.assembly) {
  initialTab = TAB_ASSEMBLY;
} else if (Spree.parts) {
  initialTab = TAB_PCB_PARTS;
} else if (Spree.accessories) {
  initialTab = TAB_ACCESSORIES;
} else {
  initialTab = TAB_FABRICATION;
}

const tabSlice = createSlice({
  name: 'tabSlice',
  initialState: {
    activeTab: initialTab,
  },
  reducers: {
    changeTab(state, action) {
      state.activeTab = action.payload;
    },
  },
});

export const {
  changeTab,
} = tabSlice.actions;

export default tabSlice.reducer;
